// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1_clR","header":"ReportDetails_header__30Dnc","title":"ReportDetails_title__3lPYC","left":"ReportDetails_left__10tcQ"};